import {
    Component, EventEmitter, Input, Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { OverlayContext } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommonHttpService } from '../../../../../shared/services/http.service';
import { PaymentMethodModel } from '../../../../../shared/models/payment-method.model';
import { SubscriptionModel } from '../../../../../shared/models/payment/subscription/subscription.model';
import { ClientModel } from '../../../../../shared/models/client.model';
import { Response } from '@angular/http';

@Component({
    selector: 'account-subscriptions-details-actions-payment-method',
    templateUrl: './account.subscriptions.details.actions.payment-method.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsPaymentMethodComponent {
    @ViewChild('templateRef') public templateRef: TemplateRef<any>;
    @Input('subscription') subscription: SubscriptionModel;
    @Input('client') client: ClientModel;
    @Output('updated') updated: EventEmitter<any> = new EventEmitter();

    protected overlayContext = new OverlayContext();
    protected data = null;
    public loading = false;
    public paymentMethod;
    public paymentMethods: Array<PaymentMethodModel>;
    public confirmed = false;
    public requestConfirmation = false;

    constructor(
        protected modal: Modal,
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService
    ) {
        this.overlayContext.inElement = false;
        this.overlayContext.isBlocking = true;
        this.overlayContext.keyboard = null;
    }

    /**
     * Open dialog to input payment method data.
     **/
    public openDialog() {
        this.loading = true;
        this.modal
            .open(this.templateRef, {context: this.overlayContext})
            .then(() => {
                this.paymentMethods = [];
                this.http.useAuth().get(
                    `/account/clients/${this.client.id}/subscriptions/${this.subscription.id}/payment-methods`
                ).subscribe((res: Response) => {
                    this.paymentMethods = res.json().data;
                    this.loading = false;
                });
            });
    }
    /**
     * Close dialog.
     **/
    public closeDialog(dialogRef: any) {
        this.paymentMethod = undefined;
        dialogRef.close();
    }
    /**
     * Call API to update subscription data.
     **/
    public save(dialogRef: any) {
        if (!this.confirmed && !this.requestConfirmation) {
            this.requestConfirmation = true;
            return;
        }

        this.loading = true;
        this.confirmed = true;
        this.http.useAuth().put(
            `/account/clients/${this.client.id}/subscriptions/${this.subscription.id}`,
            this.data
        ).subscribe(() => {
            this.translate
                .get('ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.UPDATE_PAYMENT_METHOD_MODAL.SUCCESS')
                .subscribe(message => {
                    this.loading = false;
                    this.toastr.success(message);
                    this.closeDialog(dialogRef);
                    this.updated.emit();
                });
        }, () => {
            this.translate
                .get('ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.UPDATE_PAYMENT_METHOD_MODAL.ERROR')
                .subscribe(message => {
                    this.confirmed = false;
                    this.requestConfirmation = false;
                    this.loading = false;
                    this.toastr.error(message);
                });
        });
    }
    /**
     * data property setter.
     **/
    public setData(data: any) {
        this.data = data;
    }
    /**
     * Check if payment method is checked.
     **/
    public isChecked(paymentMethod: PaymentMethodModel) {
        if (this.paymentMethod === undefined) {
            return false;
        }

        return paymentMethod.id == this.paymentMethod.id;
    }
    /**
     * paymentMethod property setter.
     **/
    public setPaymentMethod(paymentMethod: PaymentMethodModel) {
        this.paymentMethod = paymentMethod;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/subscriptions/details/actions/payment-method/account.subscriptions.details.actions.payment-method.component.ts